import { TagBadge } from "./TagBadge";
import { ShoppingIcon } from "../../icons/ShoppingIcon";
import { t } from "i18next";

export function CollectibleBadge() {
  return (
    <TagBadge
      text={t("components.slideInMenu.releaseInfoMenu.collectible")}
      background="charcoal.900"
      contentColor="neutral.200"
      icon={<ShoppingIcon boxSize="12px" color="transparent.info.80" />}
      border="1px solid"
      borderColor="transparent.info.80"
      isLarge={true}
      displayTooltip
      tooltipText={t(
        "components.slideInMenu.releaseInfoMenu.collectibleTooltip",
      )}
    />
  );
}
